import { LicensingTable } from '../LicensingTable/LicensingTable';
import { ProductCompatibilityTable } from '../ProductCompatibilityTable/ProductCompatibilityTable';
import { PublisherInfoTable } from '../PublisherInfoTable/PublisherInfoTable';
import { Separator } from '../Separator/Separator';
import { ProductNutritionLabelsProps } from './types';

const defaultEmptyPackageData = {
  renderPipelines: [],
  buildTargets: [],
  unityVersions: [],
  fileSize: '',
  latestVersion: '',
  latestRelease: '',
};

const emptySinglePackageData = {
  ...defaultEmptyPackageData,
  microcopy: {
    title: '',
    unityVersion: '',
    renderPipelines: '',
    buildTarget: '',
    fileSize: '',
    latestVersion: '',
    latestRelease: '',
  },
};

const emptyMultiPackageData = {
  ...defaultEmptyPackageData,
  microcopy: {
    title: '',
    description: '',
  },
};

export const ProductNutritionLabels = ({
  compatibility,
  licensing,
  publisher,
}: ProductNutritionLabelsProps) => {
  return (
    <>
      {compatibility.variant === 'single-package' ? (
        <ProductCompatibilityTable
          variant="single-package"
          singlePackageData={{
            ...emptySinglePackageData,
            ...compatibility?.singlePackageData,
            microcopy: {
              ...emptySinglePackageData.microcopy,
              ...compatibility?.singlePackageData?.microcopy,
            },
          }}
        />
      ) : (
        <ProductCompatibilityTable
          variant="multi-package"
          multiPackageData={{
            ...emptyMultiPackageData,
            ...compatibility?.multiPackageData,
            microcopy: {
              ...emptyMultiPackageData.microcopy,
              ...compatibility?.multiPackageData?.microcopy,
            },
          }}
        />
      )}

      <Separator />
      <LicensingTable {...licensing} />
      <Separator />
      <PublisherInfoTable {...publisher} />
    </>
  );
};
